import { render, staticRenderFns } from "./PageWidget.vue?vue&type=template&id=5e748878&"
import script from "./PageWidget.vue?vue&type=script&lang=js&"
export * from "./PageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports